import React from "react";

import ImportExportMenu from "Components/Common/DataImport/ImportExportMenu";
import { DataImportConfig } from "Components/Common/DataImport/dataImportFields";
import {
  exportContractRatingsToCSV,
  importContractRating,
} from "common/services/contracts.service";

const importConfig: DataImportConfig = {
  title: "Contract Ratings",
  entityLabel: "contract rating",
  icon: "ri-star-line",
  templateFile: "contract_ratings_import_template.csv",
  importFn: importContractRating,
  fields: [
    {
      key: "name",
      label: "Name",
      required: true,
      hint: "Must be unique across contract ratings",
    },
    { key: "isFlag", label: "Flagged", hint: "Yes or No" },
  ],
};

/** Import/export menu for the contract ratings table. */
const Import = ({ apiParams }: { apiParams?: any }) => (
  <ImportExportMenu
    resource="contract-rating"
    config={importConfig}
    exportFn={exportContractRatingsToCSV}
    exportFileName="Contract_Ratings_Export.csv"
    apiParams={apiParams}
  />
);

export default Import;
